import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, Transition as _Transition, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { id: "nav" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("img", {
  src: "/home.png",
  alt: "home"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", null, "0", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", null, "1", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", null, "2", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("img", {
  src: "/favicon.png",
  alt: "play"
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("button", {
        class: _normalizeClass({ active: _ctx.isOnRoute('/') })
      }, [
        _createVNode(_component_router_link, {
          class: "button_top nav_button",
          to: "/"
        }, {
          default: _withCtx(() => [
            _hoisted_2
          ]),
          _: 1
        })
      ], 2),
      _createElementVNode("button", {
        class: _normalizeClass({ active: _ctx.isOnRoute('/scene-0') })
      }, [
        _createVNode(_component_router_link, {
          class: "button_top nav_button",
          to: "/scene-0"
        }, {
          default: _withCtx(() => [
            _hoisted_3
          ]),
          _: 1
        })
      ], 2),
      _createElementVNode("button", {
        class: _normalizeClass({ active: _ctx.isOnRoute('/scene-1') })
      }, [
        _createVNode(_component_router_link, {
          class: "button_top nav_button",
          to: "/scene-1"
        }, {
          default: _withCtx(() => [
            _hoisted_4
          ]),
          _: 1
        })
      ], 2),
      _createElementVNode("button", {
        class: _normalizeClass({ active: _ctx.isOnRoute('/scene-2') })
      }, [
        _createVNode(_component_router_link, {
          class: "button_top nav_button",
          to: "/scene-2"
        }, {
          default: _withCtx(() => [
            _hoisted_5
          ]),
          _: 1
        })
      ], 2),
      _createElementVNode("button", {
        class: _normalizeClass({ active: _ctx.isOnRoute('/scene-3') })
      }, [
        _createVNode(_component_router_link, {
          class: "button_top nav_button",
          to: "/scene-3"
        }, {
          default: _withCtx(() => [
            _hoisted_6
          ]),
          _: 1
        })
      ], 2)
    ]),
    _createVNode(_component_router_view, null, {
      default: _withCtx(({ Component }) => [
        _createVNode(_Transition, { name: "fade" }, {
          default: _withCtx(() => [
            (_openBlock(), _createBlock(_resolveDynamicComponent(Component)))
          ]),
          _: 2
        }, 1024)
      ]),
      _: 1
    })
  ], 64))
}